<template>
	<v-container class="px-0">
		<v-container v-if="typeof report === 'string' || report instanceof String">
			<v-row>
				<v-text-field
					:model-value="$gettext(report)"
					variant="outlined"
					readonly
					hide-details
				/>
			</v-row>
		</v-container>
		<v-container
			v-else
			class="px-0"
		>
			<v-row>
				<v-col>
					<v-text-field
						:loading="reportLoading"
						:model-value="!report ? '' : report.name[0]"
						:label="$gettext('Name in Verifai')"
						:disabled="!report || !report.name[0]"
						variant="outlined"
						readonly
						hide-details
					/>
				</v-col>
				<v-col>
					<v-select
						v-model="alias"
						:loading="reportLoading"
						:items="!report ? [] : report.alias"
						:label="$gettext('Alias in Verifai')"
						:disabled="!report || !(report.alias.length > 0)"
						variant="outlined"
						hide-details
					/>
				</v-col>
				<v-col>
					<v-text-field
						:loading="reportLoading"
						:model-value="!report ? '' : report.birthDate[0]"
						:label="$gettext('Birth Date in Verifai')"
						:disabled="!report || !report.birthDate[0]"
						variant="outlined"
						readonly
						hide-details
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					<v-text-field
						:loading="reportLoading"
						:model-value="!report ? '' : report.nationality"
						:label="$gettext('Nationality in Verifai')"
						:disabled="!report || !report.nationality"
						variant="outlined"
						readonly
						hide-details
					/>
				</v-col>
				<v-col cols="8">
					<v-select
						v-model="dataset"
						:loading="reportLoading"
						:items="!report ? [] : report.url.dataset"
						:label="$gettext('Dataset url in Verifai')"
						:disabled="!report || !(report.url.dataset.length > 0)"
						variant="outlined"
						hide-details
					/>
				</v-col>
			</v-row>
			<v-row
				v-if="reportLoading && !report"
			>
				<v-col>
					<v-skeleton-loader
						type="paragraph"
					/>
				</v-col>
			</v-row>
			<v-row
				v-for="note in report.note"
				v-else
				:key="note"
			>
				<v-col>
					<v-textarea
						:loading="reportLoading"
						:model-value="note"
						:label="$gettext('Note in Verifai')"
						auto-grow
						variant="outlined"
						readonly
						hide-details
						rows="2"
					/>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>
<script>
import {
	debounce,
} from 'lodash';
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'VerifaiFields',
	props: {
		nameFirst: {
			type: String,
			default: null,
		},
		nameLast: {
			type: String,
			required: true,
		},
		birthDay: {
			type: String,
			required: true,
		},
		modelValue: {
			type: [String, Object, null, ],
			required: false,
			default: null,
		}
	},

	emits: ['update:modelValue',],

	data () {
		return {
			reportLoading: true,
			report: null,
			alias: null,
			dataset: null,
		};
	},

	watch: {
		/**
		 * Watch
		 */
		report: {
			/**
			 * Update report in parent components
			 */
			handler () {
				this.$emit('update:modelValue', this.report);
			},
		}
	},

	created () {
		this.getReport();
	},
	methods: {
		/**
		 * Retrieve the verifai report of this user
		 */
		getReport: debounce(function () {
			this.reportLoading = true;
			axios.get(`/bo/pending/verifaireport?first_name=${this.nameFirst}&last_name=${this.nameLast}&birth_day=${this.birthDay}`).then(({
				data
			}) => {
				if (data.result.matchFound) {
					this.report = data.result.matchingPerson;
					this.alias = this.report.alias.length > 0 ? this.report.alias[0] : '';
					this.dataset = this.report.url.dataset.length > 0 ? this.report.url.dataset[0] : '';
				} else {
					this.report = 'User not found in Verifai report';
				}
			}).catch(() => {
				this.report = 'Could not load Verifai report';
			}).finally(() => {
				this.reportLoading = false;
			});
		}),
	}
};
</script>
